import React from 'react';
import './ContactInfo.css';
import { Link } from 'react-router-dom';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: '📧',
      title: 'Email Support',
      description: 'Get help via email',
      contact: 'info@flowdo.biz',
      response: 'Response within 24 hours'
    },
  ];

  return (
    <div className="contact-info-container">
      <div className="info-header">
        <h2>Alternatively:</h2>
        <p className="email-link">Email us to <Link to="mailto:info@flowdo.biz">info@flowdo.biz</Link></p>
      </div>
      
      {/* <div className="contact-methods">
        {contactMethods.map((method, index) => (
          <div key={index} className="contact-method">
            <div className="method-icon">{method.icon}</div>
            <div className="method-content">
              <h3>{method.title}</h3>
              <p className="method-description">{method.description}</p>
              <div className="method-contact">{method.contact}</div>
              <div className="method-response">{method.response}</div>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default ContactInfo; 